import { Container, Row, Col, Card } from 'react-bootstrap';

const Cookies = () => {
  const cookieTypes = [
    {
      title: 'Essential Cookies',
      description: 'These cookies are necessary for the website to function properly. They enable core functionality such as security, account authentication, and remembering your login status. You cannot opt out of these cookies.',
      examples: ['Session cookies', 'Authentication cookies', 'Security cookies']
    },
    {
      title: 'Functional Cookies',
      description: 'These cookies enable enhanced functionality and personalization. They remember your preferences and settings to provide a more personalized experience. Disabling these may affect some features.',
      examples: ['Language preferences', 'Theme settings', 'Saved search filters']
    },
    {
      title: 'Analytics Cookies',
      description: 'These cookies help us understand how visitors interact with our website. They collect information about page visits, time spent, and navigation patterns. This data helps us improve our services.',
      examples: ['Google Analytics', 'Usage statistics', 'Performance monitoring']
    },
    {
      title: 'Marketing Cookies',
      description: 'These cookies are used to deliver relevant advertisements and track the effectiveness of our marketing campaigns. They may be set by us or third-party advertising partners.',
      examples: ['Ad targeting', 'Campaign tracking', 'Social media pixels']
    }
  ];

  return (
    <Container className="py-5">
      <Row className="justify-content-center mb-5">
        <Col lg={8} className="text-center">
          <h1 className="display-4 fw-bold mb-4">Cookie Policy</h1>
          <p className="text-muted">Last updated: January 1, 2024</p>
        </Col>
      </Row>

      <Row className="justify-content-center mb-5">
        <Col lg={10}>
          <Card className="border-0 shadow-sm">
            <Card.Body className="p-4 p-lg-5">
              <h5 className="fw-bold mb-3">What Are Cookies?</h5>
              <p className="text-muted mb-4">
                Cookies are small text files stored on your device when you visit a website. They help 
                websites remember your preferences, understand how you use the site, and improve your 
                experience. Cookies can be "session" cookies (deleted when you close your browser) or 
                "persistent" cookies (remain until they expire or you delete them).
              </p>

              <h5 className="fw-bold mb-3">How We Use Cookies</h5>
              <p className="text-muted mb-0">
                Paperdate uses cookies to provide a secure and personalized experience. We use cookies 
                to keep you logged in, remember your preferences, analyze site usage, and deliver 
                relevant content. Some cookies are essential for the site to work, while others help 
                us improve our services.
              </p>
            </Card.Body>
          </Card>
        </Col>
      </Row>

      <Row className="justify-content-center mb-5">
        <Col lg={10}>
          <h3 className="fw-bold mb-4">Types of Cookies We Use</h3>
          <Row>
            {cookieTypes.map((type, index) => (
              <Col md={6} key={index} className="mb-4">
                <Card className="border-0 shadow-sm h-100">
                  <Card.Body className="p-4">
                    <h5 className="fw-bold mb-3">{type.title}</h5>
                    <p className="text-muted mb-3">{type.description}</p>
                    <p className="mb-2"><strong>Examples:</strong></p>
                    <ul className="text-muted mb-0">
                      {type.examples.map((example, i) => (
                        <li key={i}>{example}</li>
                      ))}
                    </ul>
                  </Card.Body>
                </Card>
              </Col>
            ))}
          </Row>
        </Col>
      </Row>

      <Row className="justify-content-center">
        <Col lg={10}>
          <Card className="border-0 shadow-sm">
            <Card.Body className="p-4 p-lg-5">
              <h5 className="fw-bold mb-3">Managing Your Cookie Preferences</h5>
              <p className="text-muted mb-4">
                You can control and manage cookies in several ways. Most browsers allow you to refuse 
                or delete cookies through their settings. Please note that disabling certain cookies 
                may affect the functionality of our website.
              </p>

              <h5 className="fw-bold mb-3">Browser Settings</h5>
              <p className="text-muted mb-4">
                You can configure your browser to block or alert you about cookies. Each browser is 
                different, so check your browser's help menu to learn how to change your cookie 
                preferences. Note that blocking all cookies may prevent you from using some features.
              </p>

              <h5 className="fw-bold mb-3">Contact Us</h5>
              <p className="text-muted mb-0">
                If you have questions about our use of cookies, please contact us at{' '}
                <a href="mailto:privacy@paperdate.io" className="text-primary">privacy@paperdate.io</a>.
              </p>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  );
};

export default Cookies;

